// Popover.
//
// THE MOTION IS THE STYLESHEET'S, AND IT IS EXPLICIT. `popover-motion` is
// defined in the app stylesheet under § THE MOTION SYSTEM -- entrypoints/
// operator.css in the RMS, entrypoints/application.css in the PMS, and the
// block is the same in both, which is why this file can stay a byte-for-byte
// copy. A fade and a 150ms scale from the trigger's own corner, keyed off the
// `data-state` Radix stamps, with a `[data-state='closed']` rule so the panel
// LEAVES instead of vanishing.
//
// What stood here before was shadcn's `data-[state=open]:animate-in
// zoom-in-95 fade-in-0` and five siblings, which are `tailwindcss-animate`
// utilities. That package is not a dependency of either product, Tailwind
// emitted nothing for any of them, and every popover had been popping in and
// out since the day it was added -- the same finding W1 made on the dialog, in
// the same shape. A class list is not evidence that an animation runs;
// `getComputedStyle(el).animationName` is.
import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cn } from '@/lib/utils'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'end', sideOffset = 8, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'popover-motion z-50 rounded-xl border border-border/60 bg-white p-0 text-foreground shadow-lg shadow-black/8 outline-none',
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
